import { useIsJobTimedOut } from '@hooks/useIsJobTimedOut';
import { isJobInProgress } from '@partful/pages/product-library/ui/product-list/jobFiltering';
import { PartCategoriesJob } from '@providers/job/types';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdatePartCategoriesJob } from './useUpdatePartCategoriesJob';

export const usePartsCategoriesTimeoutHandler = (
  partsCategoriesJobData: PartCategoriesJob | undefined,
  accountId: string
) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('manageProduct');
  const { mutate: updatePartCategoriesJob } = useUpdatePartCategoriesJob();

  const hasJobTimedOut = useIsJobTimedOut(partsCategoriesJobData);
  const isInProgress = partsCategoriesJobData && isJobInProgress(partsCategoriesJobData);

  useEffect(() => {
    if (hasJobTimedOut && isInProgress) {
      updatePartCategoriesJob(
        {
          runID: partsCategoriesJobData?.runID!,
          accountId,
          status: 'FAILED',
          errors: [{ source: 'vtaas-ui', message: `${t('partsCategories.processingPage.timeoutError')}` }],
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries(['getPartsCategoriesJob', partsCategoriesJobData?.runID]);
          },
        }
      );
    }
  }, [accountId, hasJobTimedOut, isInProgress, partsCategoriesJobData, queryClient, t, updatePartCategoriesJob]);
};
